export default __webpack_public_path__ + "static/media/Girl1.cef35db2.png";